(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-customer-viewing"] && !Shopify.designMode) return;
  try {
    class CustomerViewingComponent extends HTMLElement {
    constructor() {
      super();
      this.timer = null;
      this.init();
    }

    init() {
      const numberElem = this.querySelector('[data-customer-viewing-number]');
      if (!numberElem) return;

      const numbersViewerStr = this.dataset.customerView;
      if (!numbersViewerStr) return;

      const numbersViewerList = numbersViewerStr
        .split(',')
        .map(item => parseInt(item.trim(), 10))
        .filter(num => !isNaN(num) && num > 0);

      if (!numbersViewerList.length) return;

      let timeViewer = parseInt(this.dataset.customerViewTime, 10);
      if (isNaN(timeViewer) || timeViewer < 1) timeViewer = 5;
      timeViewer = timeViewer * 1000;

      const updateNumber = () => {
        const randomIdx = Math.floor(Math.random() * numbersViewerList.length);
        const value = numbersViewerList[randomIdx];
        numberElem.textContent = value;
      };

      updateNumber();

      this.timer = setInterval(updateNumber, timeViewer);
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('customer-viewing-component')) {
      customElements.define('customer-viewing-component', CustomerViewingComponent);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-positive-vibes"] && !Shopify.designMode) return;
  try {
    class PositiveVibesComponent extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const parent = this.querySelector('.text-vibes');
      const children = this.querySelectorAll('.text-vibes--child');
      let currentIndex = 0;

      if (children.length > 1) {
        const newDiv = document.createElement("div");
        newDiv.classList.add("text-vibes--child");
        newDiv.innerHTML = children[0].innerHTML;
        parent.appendChild(newDiv);

        const childrenTexts = parent.querySelectorAll('.text-vibes--child');
        setInterval(() => {
          if (parent) {
            parent.classList.add('js-active');
          }
          const height = childrenTexts[currentIndex].offsetHeight;
          childrenTexts.forEach((child, index) => {
            parent.style.cssText = `transform: translateY(${height * -currentIndex}px); transition: all .5s ease;`;
            if (currentIndex == 0) {
              parent.style.cssText = `transform: translateY(${height * -currentIndex}px); transition: none;`;
            }
          });
          currentIndex = (currentIndex + 1) % childrenTexts.length;
          this.heightPositive();
        }, 3000);
      }
    }

    heightPositive() {
      const parent = this.querySelector('.text-vibes');
      const childrenTexts = this.querySelectorAll('.text-vibes--child');

      let maxHeight = 0;
      childrenTexts.forEach(child => {
        maxHeight = Math.max(maxHeight, child.querySelector('p').offsetHeight);
      });

      this.style.minHeight = maxHeight + 'px';

      childrenTexts.forEach(child => {
        child.style.minHeight = `${maxHeight}px`;
      });
    }
  }
  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('positive-vibes-component')) {
      customElements.define('positive-vibes-component', PositiveVibesComponent);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-sold-in-last"] && !Shopify.designMode) return;
  try {
    class SoldInLastComponent extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const numberElem = this.querySelector('[data-sold-out-number]');
      const hoursElem = this.querySelector('[data-sold-out-hours]');

      let numbersListStr = this.dataset.items || this.getAttribute('data-items') || "3,5,6,7,8,10,12,15";
      let hoursListStr = this.dataset.hours || this.getAttribute('data-hours') || "10,15,16,17,18,20,25,35";

      const numbersList = numbersListStr.split(',').map(item => item.trim()).filter(item => !!item);
      const hoursList = hoursListStr.split(',').map(item => item.trim()).filter(item => !!item);

      const numberIdx = Math.floor(Math.random() * numbersList.length);
      const hourIdx = Math.floor(Math.random() * hoursList.length);

      if (numberElem && numbersList.length > 0) {
        numberElem.textContent = numbersList[numberIdx];
      }
      if (hoursElem && hoursList.length > 0) {
        hoursElem.textContent = hoursList[hourIdx];
      }
      this.classList.remove('loading');
    }
  }
  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('sold-in-last-component')) {
      customElements.define('sold-in-last-component', SoldInLastComponent);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-tab-item"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const tabTitles = document.querySelectorAll('.tab-title');
    const tabContents = document.querySelectorAll('.tab-content');

    if (tabTitles.length === 0 || tabContents.length === 0) return;

    tabContents[0].classList.add('is-active');

    tabTitles.forEach(title => {
      title.addEventListener('click', function(e) {
        e.preventDefault();
        tabContents.forEach(content => {
          content.classList.remove('is-active');
        });
        const tabContent = this.nextElementSibling;
        if (tabContent) {
          tabContent.classList.add('is-active');
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-tabs"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const tabTitles = document.querySelectorAll('.tab-title');
    const tabContents = document.querySelectorAll('.tab-content');

    if (tabTitles.length && tabContents.length && tabTitles.length === tabContents.length) {
      tabTitles.forEach((title, i) => {
        title.addEventListener('click', function (e) {
          e.preventDefault();
          if (title.classList.contains('is-active')) return;
          tabTitles.forEach(t => t.classList.remove('is-active'));
          tabContents.forEach(c => c.classList.remove('is-active'));
          title.classList.add('is-active');
          setTimeout(() => {
            const content = tabContents[i];
            content.classList.add('is-animating');
            content.classList.add('is-active');
            content.addEventListener('transitionend', function handler() {
              content.classList.remove('is-animating');
              content.removeEventListener('transitionend', handler);
            });
          }, 10);
        });
      });
    }

    const toggleLinks = document.querySelectorAll('.toggle-link');

    toggleLinks.forEach(toggleLink => {
      toggleLink.addEventListener('click', function(e) {
        e.preventDefault();

        const toggleTitle = toggleLink.closest('.toggle-title');
        if (!toggleTitle) return;

        const tabTitleText = document.querySelectorAll('.tab-title-text');
        if (tabTitleText.length > 0) {
          tabTitleText.forEach(text => {
            text.textContent = toggleLink.textContent;
          });
        }

        const viewContentType = toggleTitle.dataset.viewContent;
        const content = toggleTitle.nextElementSibling;
        if (!content) return;

        switch (viewContentType) {
          case 'sidebar': {
            const drawerContent = document.querySelector('#Global-Drawer .drawer__wrapper');
            if (drawerContent) {
              drawerContent.innerHTML = '';
              drawerContent.appendChild(content.cloneNode(true));
              renderVideo();
            }
            break;
          }
          case 'popup': {
            const popupContent = document.querySelector('.popup-content-wrapper');
            if (popupContent) {
              popupContent.innerHTML = '';
              popupContent.appendChild(content.cloneNode(true));
              renderVideo();
            }
            break;
          }
          default:
            toggleTitle.classList.toggle('is-open');
        }
      });
    });
    const modalTemplate = `
      <side-drawer
        class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden"
        element-s-popup=""
        id="PopupModal-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
        data-moved="true"
      >
        <div
          id="Drawer-Overlay-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
          class="drawer__overlay fixed inset-0 cursor-pointer"
          style="transform: translateX(0px)"
        ></div>
        <div
          class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup"
        >
          <div
            class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar"
          >
            <div class="video-modal__content-block">Video</div>
            <button
              onclick="this.closest('side-drawer').close()"
              class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute"
              type="button"
              aria-label="Close dialog"
              style="--top: 0.3rem; --right: 0.3rem"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                class="icon icon-close"
                viewBox="0 0 18 17"
              >
                <path
                  fill="currentColor"
                  d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </side-drawer>
    `;
    document.body.insertAdjacentHTML('beforeend', modalTemplate);

    function renderVideo() {
      const videoOpenPopups = document.querySelectorAll('.video-open-popup');
    
      if (videoOpenPopups.length > 0) {
        videoOpenPopups.forEach(videoOpenPopup => {
          videoOpenPopup.addEventListener('click', function(e) {
            e.preventDefault();

            const videoId = videoOpenPopup.dataset.videoId;
            const videoWrapper = document.querySelector('.video-modal__content-block');

            const youtubeIframe = `
            <iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            `;

            videoWrapper.innerHTML = youtubeIframe;
          });
        });
      }
    }
    renderVideo();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["hatchill-sympl-widget"] && !Shopify.designMode) return;
  try {
    (function () {
    var wrapperSelector = '.hatchill-sympl-widget';
    var loaderUrl = 'https://assets.sympl.ai/widgets/ecom-prod-dtls/widget.min.js';
    var readinessTimeoutMs = 12000;
    var sharedLoadPromise = null;

    function ensureHatchillModalCoordinator() {
      var existing = window.HatchillModalCoordinator;
      if (existing && typeof existing.reserve === 'function' && typeof existing.release === 'function') return existing;
      var owner = null;
      var coordinator = {
        reserve: function (nextOwner) {
          if (!owner || owner === nextOwner) { owner = nextOwner; return true; }
          return false;
        },
        release: function (currentOwner) {
          if (owner === currentOwner) owner = null;
        },
        isReservedByOther: function (currentOwner) { return Boolean(owner && owner !== currentOwner); },
        currentOwner: function () { return owner; }
      };
      window.HatchillModalCoordinator = coordinator;
      return coordinator;
    }

    function track(wrapper, name, extra) {
      var payload = Object.assign({
        location: 'pdp_inline',
        placement: 'below_price',
        page_type: 'product',
        product_id: wrapper.dataset.productId,
        product_handle: wrapper.dataset.productHandle,
        store_code: 'STR-914'
      }, extra || {});
      if (window.HatchillEvents && typeof window.HatchillEvents.track === 'function') {
        window.HatchillEvents.track(name, payload);
      }
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        var published = window.Shopify.analytics.publish('hatchill:' + name, payload);
        if (published && typeof published.catch === 'function') published.catch(function () {});
      }
    }

    function setStatus(wrapper, message) {
      var status = wrapper.querySelector('[data-hatchill-sympl-status]');
      if (!status) return;
      status.textContent = message || '';
      status.hidden = !message;
    }

    function waitForDefinition() {
      return Promise.race([
        customElements.whenDefined('sympl-widget'),
        new Promise(function (_, reject) {
          window.setTimeout(function () { reject(new Error('Sympl readiness timed out')); }, readinessTimeoutMs);
        })
      ]);
    }

    function loadVendorWidget() {
      if (customElements.get('sympl-widget')) return Promise.resolve();
      if (sharedLoadPromise) return sharedLoadPromise;

      sharedLoadPromise = new Promise(function (resolveLoad, rejectLoad) {
        var loader = document.querySelector('script[data-sympl-widget-loader], script[src="' + loaderUrl + '"]');
        if (loader && loader.dataset.symplWidgetFailed === 'true') {
          loader.remove();
          loader = null;
        }
        if (!loader) {
          loader = document.createElement('script');
          loader.src = loaderUrl;
          loader.async = true;
          loader.dataset.symplWidgetLoader = '';
          document.head.appendChild(loader);
        }
        loader.addEventListener('error', function () {
          loader.dataset.symplWidgetFailed = 'true';
          loader.remove();
          rejectLoad(new Error('Sympl resources failed to load'));
        }, { once: true });
        waitForDefinition().then(resolveLoad, function (error) {
          loader.dataset.symplWidgetFailed = 'true';
          loader.remove();
          rejectLoad(error);
        });
      }).catch(function (error) {
        sharedLoadPromise = null;
        throw error;
      });
      return sharedLoadPromise;
    }

    function isRendered(element) {
      if (!element || element.hidden || element.getAttribute('aria-hidden') === 'true') return false;
      var styles = window.getComputedStyle(element);
      var rect = element.getBoundingClientRect();
      return styles.display !== 'none' && styles.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
    }

    function anotherModalIsOpen(ignoredDialog) {
      var visitedRoots = new WeakSet();
      function inspect(root) {
        if (!root || visitedRoots.has(root)) return false;
        visitedRoots.add(root);
        var dialogs = root.querySelectorAll ? root.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"], [data-hatchill-app-sheet]:not([hidden])') : [];
        for (var dialogIndex = 0; dialogIndex < dialogs.length; dialogIndex += 1) {
          if (dialogs[dialogIndex] !== ignoredDialog && isRendered(dialogs[dialogIndex])) return true;
        }
        var elements = root.querySelectorAll ? root.querySelectorAll('*') : [];
        for (var elementIndex = 0; elementIndex < elements.length; elementIndex += 1) {
          if (elements[elementIndex].shadowRoot && inspect(elements[elementIndex].shadowRoot)) return true;
        }
        return false;
      }
      return inspect(document);
    }

    function waitForRenderedDialog(widget) {
      var deadline = Date.now() + readinessTimeoutMs;
      return new Promise(function (resolveReady, rejectReady) {
        function poll() {
          var control = widget.shadowRoot && widget.shadowRoot.querySelector('.sympl-widget');
          var dialogRoot = widget.dialogEl && widget.dialogEl.shadowRoot;
          var modal = dialogRoot && dialogRoot.getElementById('sympl-modal');
          if (control && dialogRoot && modal) {
            resolveReady({ control: control, dialogRoot: dialogRoot, modal: modal });
            return;
          }
          if (Date.now() >= deadline) {
            rejectReady(new Error('Sympl rendered dialog readiness timed out'));
            return;
          }
          window.setTimeout(poll, 50);
        }
        poll();
      });
    }

    function waitForOpenModal(modal) {
      var deadline = Date.now() + readinessTimeoutMs;
      return new Promise(function (resolveOpen, rejectOpen) {
        function poll() {
          if (modal.classList.contains('open') && isRendered(modal)) {
            resolveOpen(modal);
            return;
          }
          if (Date.now() >= deadline) {
            rejectOpen(new Error('Sympl modal did not open in time'));
            return;
          }
          window.setTimeout(poll, 50);
        }
        poll();
      });
    }

    function restoreWidget(wrapper, widget) {
      ensureHatchillModalCoordinator().release('sympl');
      wrapper.dataset.hatchillSymplState = 'ready';
      widget.setAttribute('aria-expanded', 'false');
      setStatus(wrapper, '');
      window.setTimeout(function () {
        if (document.documentElement.contains(widget)) widget.focus({ preventScroll: true });
      }, 0);
    }

    function wireStandardWidget(wrapper, widget, ready) {
      if (widget.dataset.hatchillSymplReady === 'true') return;
      widget.dataset.hatchillSymplReady = 'true';
      wrapper.dataset.hatchillSymplState = 'ready';
      setStatus(wrapper, '');

      var control = ready.control;
      var dialogRoot = ready.dialogRoot;
      var modal = ready.modal;
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-label', widget.dataset.dialogLabel);
      modal.setAttribute('tabindex', '-1');

      var closeButton = modal.querySelector('.modal-close');
      var continueButton = modal.querySelector('#close .modal-exit');
      if (closeButton) closeButton.setAttribute('aria-label', widget.dataset.closeLabel);
      if (continueButton) {
        continueButton.setAttribute('role', 'button');
        continueButton.setAttribute('tabindex', '0');
      }

      var focusStyle = document.createElement('style');
      focusStyle.dataset.hatchillSymplFocusStyle = 'true';
      focusStyle.textContent = '.modal-close:focus-visible, #close .modal-exit:focus-visible { outline: 3px solid #ff395a !important; outline-offset: 3px; }';
      if (!dialogRoot.querySelector('style[data-hatchill-sympl-focus-style]')) dialogRoot.appendChild(focusStyle);

      widget.addEventListener('keydown', function (event) {
        if (event.target !== widget || event.repeat || (event.key !== 'Enter' && event.key !== ' ')) return;
        event.preventDefault();
        control.click();
      });

      widget.addEventListener('click', function (event) {
        if (modal.classList.contains('open') || wrapper.dataset.hatchillSymplState === 'opening') return;
        var modalCoordinator = ensureHatchillModalCoordinator();
        if (anotherModalIsOpen(modal) || !modalCoordinator.reserve('sympl')) {
          event.preventDefault();
          event.stopImmediatePropagation();
          wrapper.dataset.hatchillSymplState = 'blocked';
          setStatus(wrapper, wrapper.dataset.blockedMessage);
          track(wrapper, 'sympl_widget_blocked', { reason: 'another_dialog_open' });
          return;
        }

        wrapper.dataset.hatchillSymplState = 'opening';
        setStatus(wrapper, '');
        track(wrapper, 'sympl_widget_requested');
        waitForOpenModal(modal).then(function () {
          wrapper.dataset.hatchillSymplState = 'open';
          widget.setAttribute('aria-expanded', 'true');
          track(wrapper, 'sympl_widget_opened');
          window.requestAnimationFrame(function () {
            (closeButton || modal).focus({ preventScroll: true });
          });
        }).catch(function (error) {
          modalCoordinator.release('sympl');
          wrapper.dataset.hatchillSymplState = 'ready';
          setStatus(wrapper, wrapper.dataset.openError);
          track(wrapper, 'sympl_widget_failed', { reason: String(error.message || error).slice(0, 80) });
        });
      }, true);

      var modalWasOpen = modal.classList.contains('open');
      var modalObserver = new MutationObserver(function () {
        var modalIsOpen = modal.classList.contains('open');
        if (modalWasOpen && !modalIsOpen) restoreWidget(wrapper, widget);
        modalWasOpen = modalIsOpen;
      });
      modalObserver.observe(modal, { attributes: true, attributeFilter: ['class'] });

      modal.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
          modal.classList.remove('open');
          restoreWidget(wrapper, widget);
          return;
        }
        if ((event.key === 'Enter' || event.key === ' ') && event.target === continueButton) {
          event.preventDefault();
          continueButton.click();
          return;
        }
        if (event.key !== 'Tab') return;

        var focusable = [closeButton, continueButton].filter(Boolean);
        if (!focusable.length) {
          event.preventDefault();
          modal.focus();
          return;
        }
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        var active = dialogRoot.activeElement;
        if (event.shiftKey && active === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && active === last) {
          event.preventDefault();
          first.focus();
        }
      });
    }

    function initialize(root) {
      var wrappers = root.querySelectorAll ? root.querySelectorAll(wrapperSelector) : [];
      Array.prototype.forEach.call(wrappers, function (wrapper) {
        if (wrapper.dataset.hatchillSymplInitialized === 'true') return;
        wrapper.dataset.hatchillSymplInitialized = 'true';
        var widget = wrapper.querySelector('sympl-widget');
        if (!widget) return;
        var activationPromise = null;

        function activate() {
          if (widget.dataset.hatchillSymplReady === 'true') return Promise.resolve();
          if (activationPromise) return activationPromise;
          wrapper.dataset.hatchillSymplState = 'loading';
          setStatus(wrapper, '');
          activationPromise = loadVendorWidget()
            .then(function () { return waitForRenderedDialog(widget); })
            .then(function (ready) { wireStandardWidget(wrapper, widget, ready); })
            .catch(function (error) {
              activationPromise = null;
              wrapper.dataset.hatchillSymplState = 'failed';
              setStatus(wrapper, wrapper.dataset.loadError);
              track(wrapper, 'sympl_widget_failed', { reason: String(error.message || error).slice(0, 80) });
            });
          return activationPromise;
        }

        widget.addEventListener('pointerenter', activate);
        widget.addEventListener('focus', activate);
        widget.addEventListener('click', activate, true);

        if ('IntersectionObserver' in window) {
          var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              observer.disconnect();
              activate();
            });
          }, { rootMargin: '200px' });
          observer.observe(widget);
        } else {
          activate();
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initialize(document); }, { once: true });
    } else {
      initialize(document);
    }
    document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["store-locator"] && !Shopify.designMode) return;
  try {
    (function() {
    var root = document.querySelector('.storeLocator');
    if (!root) return;

    var items = root.querySelectorAll('.storeLocator__item');
    var mapEl = root.querySelector('#map');
    if (!mapEl || !items.length) return;

    function setActive(item) {
      items.forEach(function(i) { i.classList.remove('active'); });
      item.classList.add('active');
    }

    function renderMapFrom(item) {
      var html = item.getAttribute('data-map') || '';
      mapEl.classList.add('is-loading');
      mapEl.innerHTML = html;

      setTimeout(function() {
        mapEl.classList.remove('is-loading');
      }, 500);
    }

    items.forEach(function(item) {
      item.addEventListener('click', function(e) {
        e.preventDefault();
        setActive(item);
        renderMapFrom(item);
      });
    });

    // Initialize with first item
    var first = items[0];
    if (first) {
      setActive(first);
      renderMapFrom(first);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
